export { default as ProductsIndexPageCategoriesNavList } from './ProductsIndexPageCategoriesNavList';
